const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;
const MILLISECONDS_PER_HOUR = 1000 * 60 * 60;
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

const EXPRESS_SCHEDULED_WINDOWS = [
  { start: '09:00', end: '11:00' },
  { start: '11:00', end: '13:00' },
  { start: '13:00', end: '15:00' },
  { start: '15:00', end: '17:00' },
  { start: '17:00', end: '19:00' },
];

function isValidTimeFormat(timeString) {
  if (typeof timeString !== 'string') {
    return false;
  }
  return TIME_REGEX.test(timeString);
}

function timeStringToMinutes(timeString) {
  const [hours, minutes] = timeString.split(':').map(Number);
  return hours * MINUTES_PER_HOUR + minutes;
}

function calculateSlotDuration(orderFrom, orderUntil) {
  if (!isValidTimeFormat(orderFrom) || !isValidTimeFormat(orderUntil)) {
    return null;
  }

  const fromMinutes = timeStringToMinutes(orderFrom);
  const untilMinutes = timeStringToMinutes(orderUntil);

  let durationMinutes = untilMinutes - fromMinutes;

  if (durationMinutes <= 0) {
    durationMinutes += MINUTES_PER_DAY;
  }

  return durationMinutes / MINUTES_PER_HOUR;
}

function findWindowEndForCreatedAt(routeDate) {
  const hoursStr = routeDate.getHours().toString().padStart(2, '0');
  const minutesStr = routeDate.getMinutes().toString().padStart(2, '0');
  const createdAtTime = `${hoursStr}:${minutesStr}`;

  const nextWindow = EXPRESS_SCHEDULED_WINDOWS.find(
    (window) => createdAtTime < window.start
  );
  return nextWindow ? nextWindow.end : null;
}

export default function getOrderLimitTime({
  orderFrom,
  orderUntil,
  routeCreateAt,
}) {
  if (!orderFrom || !orderUntil || !routeCreateAt) {
    return null;
  }

  const routeDate = new Date(routeCreateAt);
  if (isNaN(routeDate.getTime())) {
    return null;
  }

  const windowEnd = findWindowEndForCreatedAt(routeDate);
  if (windowEnd) {
    return windowEnd;
  }

  const slotDuration = calculateSlotDuration(orderFrom, orderUntil);
  if (slotDuration === null) {
    return null;
  }

  const limitTime = new Date(
    routeDate.getTime() + slotDuration * MILLISECONDS_PER_HOUR
  );

  const limitHours = limitTime.getHours().toString().padStart(2, '0');
  const limitMinutes = limitTime.getMinutes().toString().padStart(2, '0');

  return `${limitHours}:${limitMinutes}`;
}
